<h1 mat-dialog-title>{{ 'companies.detail.privacyDocsCard.studioSection.dialog.addTitle' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 col-md-6 text-left">
          <a mat-button (click)="onClose()" mat-raised-button mat-default
            class="ml-3">{{ 'common.cta.close' | translate }}</a>
        </div> <!-- /.col -->
        <div class="col-12 col-md-6 text-right">
          <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
          </mat-spinner-button>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
